import React, { Component } from "react";

import { withStyles } from "@material-ui/core/styles";

import $ from "jquery";

import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Input,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Paper
} from "@material-ui/core";

const styles = theme => ({
  mainRequest: {
    display: "flex",
    flexDirection: "column",
    padding: ".5rem",
    flexGrow: 1
  },
  paperCls: {
    padding: "0rem .5rem",
    display: "flex",
    flexDirection: "column"
  },
  textField: {
    marginTop: "1rem"
  },
  formControl: {
    marginTop: "1.5rem"
  },
  mb1: {
    marginBottom: "1.5rem"
  },
  storeGroup: {
    display: "flex"
  },
  storeFilter: {
    marginRight: ".5rem"
  },
  storeSelect: {
    width: "100%"
  },
  storeFilterToggle: {
    whiteSpace: "nowrap",
    marginLeft: ".1rem",
    marginTop: ".75rem",
    marginRight: ".25rem"
  },
  badgecls: {
    // width:25,
    // height:25,
    left: 32
  }
});

class WorkRequest extends Component {
  constructor() {
    super();

    this.state = {
      isProd: true,
    };
  }

  componentWillMount = () => {};

 
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainRequest}>
        <TextField
          label="Store Number"
          //   value={this.state.customerDescription}
          className={[classes.descriptionItem, classes.mr1].join(" ")}
          onChange={ (evt) => this.props.propertyChangedEvent("storeNumber", evt.target.value)}
          margin="normal"
        />

        <TextField
          label="Street Address"
          //   value={this.state.customerDescription}
          className={[classes.descriptionItem, classes.mr1].join(" ")}                                                              
          onChange={ (evt) => this.props.propertyChangedEvent("streetAddress", evt.target.value)}
          margin="normal"
        />
        <TextField
          label="City"
          //   value={this.state.customerDescription}
          className={[classes.descriptionItem, classes.mr1].join(" ")}
          onChange={ (evt) => this.props.propertyChangedEvent("city", evt.target.value)}
          margin="normal"
        />

        <TextField
          label="State"
          //   value={this.state.customerDescription}
          className={[classes.descriptionItem, classes.mr1].join(" ")}
          onChange={ (evt) => this.props.propertyChangedEvent("state", evt.target.value)}
          margin="normal"
        />

        <TextField
          label="Zip Code"
          //   value={this.state.customerDescription}
          className={[classes.descriptionItem, classes.mr1].join(" ")}
          onChange={ (evt) => this.props.propertyChangedEvent("zipCode", evt.target.value)}
          margin="normal"
        />
      </div>
    );
  }
}

export default withStyles(styles)(WorkRequest);
